import { SubItem } from "@/layout/Sidemenu/components/SubItem";
import type { MaterialIconType } from "@/types/MaterialIcons";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
	Collapse,
	ListItem,
	ListItemIcon,
	ListItemText,
	alpha,
} from "@mui/material";
import { blueGrey } from "@mui/material/colors";
import Link from "next/link";
import type { UrlObject } from "node:url";
import { useToggle } from "usehooks-ts";

export type SidemenuSubItem = {
	value: string;
	title: string;
	link: `/${string}`;
};

export type SidemenuItemProps = {
	value: string;
	title: string;
	link?: `/${string}` | UrlObject;
	Icon: MaterialIconType;
	subItems?: SidemenuSubItem[];
};

export function SidemenuItem({
	title,
	link,
	Icon,
	subItems,
}: SidemenuItemProps) {
	const [open, toggleOpen] = useToggle(false);

	const hasSubItems = !!subItems?.length;
	const ExpandIcon = open ? ExpandLess : ExpandMore;

	return (
		<>
			<ListItem
				sx={{
					paddingBlock: 0.15,
					paddingLeft: 1.5,
					paddingRight: 1,
					borderRadius: 1,
					cursor: "pointer",
					"&:hover": {
						backgroundColor: alpha(blueGrey[800], 0.1),
					},
				}}
				disableGutters
				disablePadding
				component={link ? Link : "div"}
				href={link}
				onClick={hasSubItems ? toggleOpen : undefined}
			>
				<ListItemIcon sx={{ minWidth: "20px", paddingRight: 1.25 }}>
					<Icon sx={{ color: blueGrey[700], width: 20, height: 20 }} />
				</ListItemIcon>
				<ListItemText
					sx={{ color: blueGrey[800] }}
					slotProps={{
						primary: {
							fontSize: "0.95rem",
						},
					}}
					primary={title}
				/>
				{hasSubItems && <ExpandIcon sx={{ opacity: 0.8 }} />}
			</ListItem>

			{hasSubItems && subItems.length > 0 && (
				<Collapse
					in={open}
					timeout='auto'
					unmountOnExit
					sx={{ paddingBottom: 0.5 }}
				>
					{subItems.map((subItem) => (
						<SubItem
							key={subItem.value}
							title={subItem.title}
							link={subItem.link}
						/>
					))}
				</Collapse>
			)}
		</>
	);
}
